<template>
  <div class="card">
    <div class="card__media">
      <div class="absolute z-10 bottom-0 left-0 w-full p-3 md:p-4" v-if="restaurant?.logo">
        <div class="relative z-10 w-24 h-12 invert" v-if="restaurant.logo">
          <AtomImage class="h-full !object-contain object-left-bottom" :src="useCloudinaryImage(restaurant.logo, 300, null, 'fit,e_trim')" :alt="restaurant.name" />
        </div>
        <div class="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-25% from-black/80"></div>
      </div>
      <AtomImage class="object-cover" :src="post.image?.src?.squareMedium || post.image?.url" :alt="post.image?.alt || post?.title" v-if="post.image" />
    </div>
    <div class="card__info">
      <NuxtLink v-if="restaurant?.slug" :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug }}" :aria-label="restaurant.name">
        <h3 class="card__heading" v-html="post.title" />
      </NuxtLink>
      <h3 v-else class="card__heading" v-html="post.title" />
      <div class="card__description markdown" v-html="useMarked(post.excerpt)" />
      <div class="grid gap-4 mt-4 md:mt-6">
        <AtomRestaurantLocation v-if="restaurant?.address"
          :name="restaurant.address"
          :address="restaurant.city" />
        <div class="flex gap-4 text-sm">
          <button class="button-coral" @click="useOpenWidget(restaurant.hash)" v-if="restaurant?.bookable">
            {{ $t('shared.bookTable') }}
          </button>
          <NuxtLink v-if="restaurant?.slug && restaurant?.bookable" class="button-coral-outline" :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug }}" :aria-label="restaurant.name">
            {{ $t('shared.readMore') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  post: Object,
  restaurant: Object,
})
</script>

<style lang="scss" scoped>
.card {
  @apply grid md:flex md:flex-row md:items-center;
  @apply bg-mist rounded overflow-hidden;

  &__media {
    @apply relative aspect-video md:aspect-auto;
    @apply md:w-2/5 md:max-w-sm md:h-full;
  }

  &__info {
    @apply grid gap-1 p-4 md:py-6 md:px-8 lg:px-12;
    @apply md:w-3/5;
  }

  &__heading {
    @apply font-heading font-medium; 
    @apply text-3xl md:text-4xl lg:text-5xl;
  }

  &__description {
    @apply mt-1 leading-6;
  }
}
</style>